var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseCardV2',{staticClass:"pa-2",attrs:{"has-btn-action":false,"titre":_vm.titre}},[(_vm.loading)?_c('BaseLoader'):_vm._e(),(_vm.erreur && !_vm.loading)?_c('BaseMessageServerError'):_vm._e(),(!_vm.loading)?_c('div',{staticClass:"my-2"},[_c('RepartitionValueDoughnut',{attrs:{"value":_vm.selected && _vm.selected.code,"data":{
        items: _vm.parts,
        value: _vm.repartition && _vm.repartition.codeParametreAdherent
      }}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }